<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <Alert
            v-if="saveFailed"
            :alert="{
              type: 'danger',
              title: 'Tidak Dapat Menyimpan Data',
              content:
                'Terjadi kesalahan saat menyimpan data, mohon periksa kembali data yang Anda masukkan. Pastikan tidak ada nilai negatif pada embalase dan tuslah serta pastikan jumlah lebih dari 0',
            }"
          />
          <Alert
            v-if="saveSuccess"
            :alert="{
              type: 'success',
              title: 'Berhasil Menyimpan Data',
              content: 'Penyimpanan data berhasil dilakukan',
            }"
          />
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <IntroOperasi
            :detailTop="introRalanOperasi.introRalan"
            :detailBottom="introRalanOperasi.introOperasi"
            :steps="steps"
          />
          <!--form action="/ralan/save" method="POST" enctype="multipart/form-data"-->
          <h4 class="my-4">Pemberian Obat dan Alat Kesehatan</h4>
          <div style="position: relative">
            <div class="form-group">
              <div class="input-group">
                <input
                  type="text"
                  :class="
                    'form-control form-control-lg pl-5 with-icon-left without-label ' +
                      (isError ? 'error' : '')
                  "
                  placeholder="Cari kode atau nama obat di sini"
                  @input="
                    (e) => {
                      a_obat = false;
                      s_obat = e.target.value;
                      updateForm();
                    }
                  "
                  :value="s_obat"
                  v-on:keyup.enter="() => search('obat')"
                />
                <i
                  class="material-symbols-outlined"
                  style="margin-top: -0.25rem"
                  >search</i
                >
                <div class="input-group-append">
                  <button
                    class="btn btn-secondary btn-with-icon-left"
                    @click="() => search('obat')"
                  >
                    <i class="material-symbols-outlined">search</i>
                    CARI
                  </button>
                </div>
              </div>
            </div>
            <SearchResult
              type=""
              @addItem="(item) => addItem(item, 'obat')"
              v-if="s_obat && a_obat"
              :loading="l_obat"
              :data="r_obat"
            />
            <table v-if="obat.length" class="responsive">
              <thead>
                <th>KODE</th>
                <th>NAMA BARANG</th>
                <th>JENIS OBAT</th>
                <th>LOKASI</th>
                <th>HARGA/PC</th>
                <th>JUMLAH</th>
                <th>EMBALASE</th>
                <th>TUSLAH</th>
                <th>SUB TOTAL</th>
                <th></th>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in obat"
                  v-bind:key="item.id + Math.random(1024)"
                  v-show="!item.deleted"
                >
                  <td>{{ item.kode }}</td>
                  <td>{{ item.nama }}</td>
                  <td>{{ item.jenis }}</td>
                  <td>{{ item.lokasi }}</td>
                  <td>{{ item.formatted_harga }}</td>
                  <td>
                    <InputNumber
                      @handleChange="(e) => handleChange(e)"
                      :value="item.jumlah"
                      :input="{ class: 'inline', name: 'jumlah-' + index }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.embalase"
                      :input="{
                        class: 'group-inline',
                        name: 'embalase-' + index,
                      }"
                    />
                  </td>
                  <td>
                    <InputMoney
                      @handleChange="(e) => handleChange(e)"
                      :value="item.tuslah"
                      :input="{
                        class: 'group-inline',
                        name: 'tuslah-' + index,
                      }"
                    />
                  </td>
                  <td>{{ convertToRupiah(item.sub_total) }}</td>
                  <td>
                    <button
                      class="btn btn-icon btn-danger btn-sm"
                      @click="() => deleteItem('obat', item.id)"
                    >
                      <i class="material-symbols-outlined">delete</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="py-1 my-5"></div>
          <div class="card p-3 float-bottom">
            <div class="row">
              <div class="col-md-12">
                <button
                  @click="saveAndContinue"
                  class="
                    btn btn-primary btn-with-icon-left
                    float-right
                    ml-3
                    text-uppercase
                  "
                >
                  <i class="material-symbols-outlined">check_circle</i>
                  SIMPAN DAN LANJUTKAN
                </button>
                <button
                  class="btn btn-outline-secondary float-right text-uppercase"
                  @click="save"
                >
                  SIMPAN
                </button>
              </div>
            </div>
          </div>

          <!--/form-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import SearchResult from "@/components/SearchResult.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import IntroOperasi from "@/components/IntroOperasi.vue";
import InputMoney from "@/components/InputMoney.vue";
import InputNumber from "@/components/InputNumber.vue";
import Alert from "@/components/Alert.vue";
import {
  setOperationIntro,
  convertToRupiah,
  discounted,
  formatDiscount,
} from "@/data/helper.js";
//console.log(discounted);
//console.log(formatDiscount);
// import { HTTP,HTTP_ENC } from "@/config.js";
import { dataOperasi } from "@/data/OperasiForm.js";
export default {
  name: "OperasiFormObat",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    Alert,
    InputMoney,
    InputNumber,
    IntroOperasi,
    SearchResult,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      data: dataOperasi,
      detailTop: null,
      id_operasi: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      saveSuccess: false,
      saveFailed: false,
      n: 0,
      s_obat: "",
      r_obat: [],
      obat: [],
      a_obat: false,
      l_obat: false,
      isError: false,
      jumlah: [],
      embalase: [],
      tuslah: [],
      convertToRupiah: convertToRupiah,
    };
  },
  methods: {
    save: async function() {
      this.handleForm();
    },
    continue: function() {
      this.$router.push(
        `/operasi/form-biaya/${this.$route.params.id_ralan}/${this.$route.params.id}`
      );
    },
    saveAndContinue: async function() {
      this.handleForm(this.continue);
    },
    handleForm: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_operasi_obat)
        ).length;
        let obats =
          this.obat && this.obat.length
            ? this.obat
                .filter((item) => !(item.deleted && !item.id_operasi_obat))
                .map((item) => {
                  return {
                    operation: item.deleted ? "delete" : null,
                    id_operasi: self.id_operasi,
                    id_obat: item.id,
                    embalase: item.embalase,
                    tuslah: item.tuslah,
                    jumlah: item.jumlah,
                  };
                })
            : [];
        if (obats && obats.length) {
          try {
            let result = await this.$store.state.HTTP_JSON.post(
              `/operasi_obat-bulk`,
              { obats }
            );
            //console.log(result);
            if (!result || result.status != 200) {
              this.saveFailed = true;
              this.saveSuccess = false;
              this.checkSuccess();
              return;
            }
          } catch (e) {
            //console.log(e);
            this.saveFailed = true;
            this.saveSuccess = false;
            this.checkSuccess();
            return;
          }
        }
        this.checkSuccess();
      } else {
        //console.log(valid);
        this.saveFailed = true;
        this.saveSuccess = false;
        this.checkSuccess();
      }
    },
    handleFormOld: async function() {
      let self = this;
      self.errors = [];
      let valid = this.validateForm();
      if (valid) {
        self.n = this.obat.filter(
          (item) => !(item.deleted && !item.id_operasi_obat)
        ).length;

        this.obat.forEach(async function(item) {
          //n-=1;
          if (!item.deleted) {
            let body = `id_operasi=${self.id_operasi}&id_obat=${item.id}&harga=${item.harga}&jumlah=${item.jumlah}&embalase=${item.embalase}&tuslah=${item.tuslah}&sub_total=${item.sub_total}`;
            if (!item.id_operasi_obat) {
              await self.saveData(body);
            } else {
              await self.saveData(body, item.id_operasi_obat);
            }
          } else {
            if (item.id_operasi_obat) {
              await self.deleteData(item.id_operasi_obat);
            }
          }
        });
      } else {
        //console.log(valid);
      }
    },
    async saveData(body, id) {
      try {
        if (id) {
          let result = await this.$store.state.HTTP_ENC.put(
            `operasi_obat/${id}`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        } else {
          let result = await this.$store.state.HTTP_ENC.post(
            `operasi_obat`,
            body
          );
          //console.log(result);
          if (result.status == "200") {
            this.n = this.n - 1;
            if (this.n == 0) {
              this.checkSuccess();
            }
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    async deleteData(id) {
      try {
        let result = await this.$store.state.HTTP_ENC.delete(
          `operasi_obat/${id}`
        );
        //console.log(result);
        if (result.status == "200") {
          this.n = this.n - 1;
          if (this.n == 0) {
            this.checkSuccess();
          }
        }
      } catch (e) {
        //console.log(e);
        this.saveFailed = true;
        this.saveSuccess = false;
      }
    },
    checkSuccess() {
      if (!this.saveFailed) {
        this.saveSuccess = true;
        var that = this;
        setTimeout(function() {
          that.saveSuccess = false;
          that.$router.push(
            `/operasi/form-biaya/${that.$route.params.id_ralan}/${that.$route.params.id}`
          );
        }, 1000);
      }
    },
    handleChange(e) {
      // if (e.target.type == "file") {
      //   if(e.target.files && e.target.files.length) { this.formSet[e.target.name] = e.target.files[0]; }
      // } else {
      //   this.formSet[e.target.name] = e.target.value;
      // }
      let name = e.target.name.split("-")[0];
      let index = e.target.name.split("-")[1];
      this.obat[index][name] = parseInt(e.target.value || 0);
      //console.log(this.obat[index][name]);
      this.obat[index]["sub_total"] =
        this.obat[index].jumlah * this.obat[index].harga +
        this.obat[index].embalase +
        this.obat[index].tuslah;
      this.obat.splice(index, 1, this.obat[index]);
      //console.log(this.obat[index]);
      // this.updateForm();
    },

    updateForm() {
      // this.obatForm[0].columns[0].value=String(this.formSet['id_petugas']);
      // this.obatForm[0].columns[1].value=String(this.formSet['id_dokter']);
      // this.labForm[0].columns[0].value=String(this.formSet['id_petugas_lab']);
      // this.labForm[0].columns[1].value=this.formSet['lab_type'];
    },
    validateForm: function() {
      let valid = true;
      // let self = this;
      this.obat.forEach((item) => {
        if (
          parseInt(item.jumlah) < 1 ||
          parseInt(item.embalase) < 0 ||
          parseInt(item.tuslah) < 0
        ) {
          valid = false;
          return;
        }
      });
      return valid;
    },
    fetchData: async function() {
      try {
        let result = await this.$store.state.HTTP.get(
          `operasi_obat?id_operasi=${this.$route.params.id}`
        );
        let self = this;
        self.obat = [];
        //console.log(result);
        if (result.status == "200") {
          result.data.data.forEach((item) => {
            item.id_operasi_obat = item.id;
            item.id = item.obat.id;
            item.kode = item.obat.kode;
            item.nama = item.obat.nama;
            item.jenis = item.obat.jenis;
            item.lokasi = item.obat.lokasi;
            self.obat.push(item);
          });
          self.obat = self.obat.filter(function(item) {
            return item.status != "DIBATALKAN";
          });
        }
      } catch (e) {
        //console.log(e);
      }
    },
    search: async function(type) {
      //console.log(type);
      this["a_" + type] = true;
      this["l_" + type] = true;
      let url = "obat";
      try {
        let result = await this.$store.state.HTTP.get(
          `${url}?q=${this["s_" + type]}`
        );
        //console.log(result);
        if (result.status == "200") {
          // this['r_'+type]=result.data;
          let self = this;
          this["r_" + type] = result.data.map(function(item) {
            item.formatted_diskon = formatDiscount(
              item.tipe_diskon,
              item.diskon
            );
            item.harga_awal = item.harga;
            item.harga = discounted(
              parseInt(item.harga),
              item.tipe_diskon,
              parseFloat(item.diskon)
            );
            item.formatted_harga = self.convertToRupiah(item.harga);
            //console.log(item);
            return item;
          });
          //console.log(this['r_'+type]);
          self["l_" + type] = false;
        } else {
          this["r_" + type] = [];
          self["l_" + type] = false;
        }
      } catch (e) {
        this["r_" + type] = [];
        this["l_" + type] = false;
      }
    },
    addItem: async function(item, type) {
      if (!this[type].find((el) => el.id == item.id)) {
        item.jumlah = 1;
        item.embalase = 0;
        item.tuslah = 0;
        item.sub_total = item.harga;
        this[type].push(item);
      }
      this["r_" + type] = [];
      this["s_" + type] = "";
      this["a_" + type] = false;
      //console.log(this[type]);
    },
    deleteItem: async function(type, id) {
      this[type] = this[type].map(function(item) {
        if (item.id == id) {
          item.deleted = true;
        }
        return item;
      });
      //console.log(this[type]);
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  // created() {
  //   window.addEventListener(
  //     "hashchange",
  //     () => {
  //       // Do something when the hash changes
  //       location.reload();
  //     },
  //     false
  //   );
  // },
  mounted: async function() {
    // this.formSet['id_operasi']=this.$route.params.id;
    this.id_operasi = this.$route.params.id;
    this.steps = [
      {
        link: `/operasi/form-laporan/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Laporan Operasi",
      },
      {
        link: `/operasi/form-tindakan/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Tindakan Operasi",
      },
      {
        link: `/operasi/form-obat/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Obat dan Alat Kesehatan",
        active: true,
      },
      {
        link: `/operasi/form-biaya/${this.$route.params.id_ralan}/${this.$route.params.id}`,
        label: "Detail Biaya",
      },
    ];
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.operasi.id_ralan}`
        );
        this.ralan = result2.data;
        this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
    await this.fetchData();
  },
};
</script>
